<template>
  <div v-if="pixDetail" class="modal-overlay-comprovante" @click.self="$emit('close')">
    <div class="modal-content-comprovante" @click.stop>

      <div class="pix-receipt-inner">
        <div class="d-flex align-items-center justify-content-end header-controls">
          <button type="button" class="btn btn-link text-muted p-0 close-btn" @click="$emit('close')">
            <i class="icon-x"></i>
          </button>
        </div>
        <div class="receipt-body">
          <div class="text-center mb-4">
            <label class="main-value-label-top">R$ {{ formatCurrency(pixDetail.value) }}</label>
            <p class="transfer-title">{{ pixDetail.description || 'Transferência recorrente de débito Pix' }}</p>
            <p class="text-uppercase text-status-line">
                ENVIADA EM {{ formatDateTime(pixDetail.sentAt) }}
            </p>
          </div>
          <div class="text-center mb-4 text-controls">
            <p class="next-transfer-date text-muted">
                PRÓXIMA TRANSFERÊNCIA AGENDADA PARA {{ formatDate(pixDetail.nextTransferDate) }}
            </p>
            <div class="status-pill-enviada">ENVIADA</div>
          </div>
          <div v-if="pixDetail.message" class="message-full-width-block">
              {{ pixDetail.message }}
          </div>
          <div class="financial-details-section">
            <label class="section-detail-label">Valor</label>
            <h4 class="section-value">R$ {{ formatCurrency(pixDetail.value) }}</h4>
            <div class="detail-line">
                <label>TAXA DE TRANSFERÊNCIA</label>
                <p>R$ {{ formatCurrency(pixDetail.fee) }}</p>
            </div>
            <div class="detail-line">
                <label>VALOR DEBITADO DA SUA CONTA</label>
                <p>R$ {{ formatCurrency(pixDetail.totalDebited) }}</p>
            </div>
          </div>
          <div class="mt-4 account-details-section">
            <h4 class="font-weight-normal section-origin-title">ORIGEM</h4>
            <div class="account-details-grid">
              <p class="account-line"><label>{{ pixDetail.origin.name }}</label></p>
              <p class="account-line"><label>Agência:</label> {{ pixDetail.origin.agency }}</p>
              <p class="account-line"><label>Conta Corrente:</label> {{ pixDetail.origin.account }}</p>
              <p class="account-line"><label>Documento:</label> {{ maskDocument(pixDetail.origin.document) }}</p>
            </div>
          </div>
          <div class="mt-4 account-details-section">
            <h4 class="font-weight-normal section-origin-title">DESTINO</h4>
            <div class="account-details-grid">
              <p class="account-line"><label>{{ pixDetail.destination.name }}</label></p>
              <p class="account-line"><label>Agência:</label> {{ pixDetail.destination.agency }}</p>
              <p class="account-line"><label>Conta Corrente:</label> {{ pixDetail.destination.account }}</p>
              <p class="account-line"><label>Documento:</label> {{ maskDocument(pixDetail.destination.document) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPixRecurringReceiptModal',
  props: {
    pixDetail: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatCurrency(value) {
      if (value == null) return '0,00';
      return Number(value)
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatDateTime(date) {
      const d = new Date(date);
      return d.toLocaleTimeString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', ' ');
    },
    formatDate(date) {
      const d = new Date(date);
      return d.toLocaleDateString('pt-BR');
    },
    maskDocument(document) {
      if (!document) return '';
      if (document.length === 11)
        return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '***.***.***-**');
      if (document.length === 14)
        return document.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          '**.***.***/****-**'
        );
      return document;
    },
  },
};
</script>

<style scoped>
.modal-overlay-comprovante {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(0, 0, 0, 0.6) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 100001 !important;
}

.modal-content-comprovante {
  background: white !important;
  border-radius: 12px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  position: relative !important;
  padding: 24px 20px;
}

.header-controls {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
}
.close-btn {
    font-size: 1.5rem;
    color: #333 !important;
}

.main-value-label-top {
    display: block;
    font-size: 2.5rem;
    font-weight: 300;
    color: #333;
    margin-bottom: 5px;
}

.transfer-title {
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 5px;
    color: #333;
}

.text-status-line {
    font-size: 0.75rem;
    font-weight: 500;
    color: #007bff !important;
    margin-bottom: 20px;
}

.next-transfer-date {
    font-size: 0.8rem;
    font-weight: 400;
    color: #6c757d;
    margin-bottom: 10px;
}

.status-pill-enviada {
    background-color: #007bff;
    color: white;
    padding: 5px 15px;
    font-size: 0.9rem;
    font-weight: 500;
    display: inline-block;
    cursor: default;
    pointer-events: none;
    border-radius: 50px;
}

.message-full-width-block {
    background-color: #007bff;
    color: white;
    padding: 10px 15px;
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 20px;
    margin-left: -20px;
    margin-right: -20px;
    text-align: center;
}

.financial-details-section {
    padding-top: 20px;
    margin-bottom: 20px;
}

.section-detail-label {
    display: block;
    font-size: 0.8rem;
    color: #6c757d;
    font-weight: 400;
    margin-bottom: -5px;
    text-align: left;
}

.section-value {
    font-size: 1.5rem;
    font-weight: 500;
    color: #333;
    margin-bottom: 15px;
    text-align: left;
}

.detail-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #eee;
    padding: 8px 0;
}

.detail-line:last-child {
    border-bottom: 1px solid #eee;
}

.detail-line label {
    font-size: 0.8rem;
    color: #6c757d;
    text-transform: uppercase;
    font-weight: 400;
    margin-bottom: 0;
}

.detail-line p {
    font-size: 0.9rem;
    font-weight: 500;
    color: #333;
    margin-bottom: 0;
}

.section-origin-title {
    font-size: 1rem;
    font-weight: 500 !important;
    margin-bottom: 10px !important;
    color: #333;
}

.account-details-grid {
    font-size: 0.9rem;
}

.account-line {
    margin-bottom: 5px;
    color: #333;
}
.account-line label {
    font-weight: 500;
    margin-right: 5px;
    color: #333;
}
.account-line p {
    display: inline;
    font-weight: 400;
}
</style>
